<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form" >
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="form.type" clearable  placeholder="全部">
                        <el-option
                            v-for="item in lessonTypes"
                            :key="item.optionValue"
                            :label="item.optionText"
                            :value="item.optionValue">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="体系类型">
                    <el-select v-model="form.useType" clearable placeholder="编程语类型言">
                        <el-option label="通用体系" :value="1"></el-option>
                        <el-option label="充值体系" :value="2"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <!-- <el-button type="primary" @click="add()">新增</el-button> -->
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    width="160"
                    label="封面">
                    <template slot-scope="scope">
                        <el-image
                            style="width: 150px; height: 90px"
                            :src="scope.row.coverImg"
                            :lazy="true"
                            :preview-src-list="[scope.row.coverImg]"
                            fit="fill"></el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="name"
                    label="系列课名称" >
                </el-table-column>
                <el-table-column
                    min-width="120"
                    prop="suitCrowd"
                    label="适合人群" >
                </el-table-column>
                <el-table-column
                    prop="lessonCount"
                    min-width="120"
                    label="课程数" >
                </el-table-column>
                <el-table-column
                    prop="typeName"
                    min-width="120"
                    label="类型" >
                </el-table-column>
                <el-table-column
                    prop="useTypeName"
                    min-width="120"
                    label="体系类型" >
                </el-table-column>
                <el-table-column
                    min-width="200"
                    label="标签">
                    <template slot-scope="scope">
                        <tag-group :tags="scope.row.tagArray" size="mini" ></tag-group>
                    </template>
                </el-table-column>
               <!-- <el-table-column
                    min-width="120"
                    label="是否开启" >
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.enable"
                                   @change="modifyEnable(scope.row)"
                                   inactive-color="#ff4949">
                        </el-switch>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column
                    min-width="180"
                    prop="createTime"
                    label="创建时间" >
                </el-table-column> -->
             <!--   <el-table-column
                    min-width="180"
                    label="授权班级" >
                    <template slot-scope="scope">
                        <el-button type="primary" size="small" @click="setClass(scope.row)">授权</el-button>
                    </template>
                </el-table-column> -->
                <el-table-column
                    label="操作"
                    min-width="150"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <br>
                        <el-link type="primary" @click="setLesson(scope.row)"
                                 :underline="false" ><i class="iconfont icon-tushu"></i><b>课程</b></el-link>
                        <br>
                        <!-- <el-popconfirm @onConfirm="del(scope.row)"
                                       title="确认删除该体系吗？"
                        >
                            <el-link type="danger" slot="reference"
                                     :underline="false" ><i class="iconfont icon-shanchu"></i><b>删除</b></el-link>
                        </el-popconfirm> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>

        <AddDraw v-if="showAdd" @submit="loadData"
                  @close="showAdd=false" :item="editItem"></AddDraw>
        <EditDraw v-if="showEdit" @submit="loadData"
                  @close="showEdit=false" :item="editItem"></EditDraw>
        <ClassDraw v-if="showClass"
                  @close="showClass=false" :item="editItem"></ClassDraw>
    </div>
</template>

<style scoped>

</style>
<style>

</style>

<script>

    import AddDraw from './LessonSystemAddDrawer';
    import EditDraw from './LessonSystemEditDrawer';
    import ClassDraw from './LessonSystemClassDrawer';


    import {mapMutations} from "vuex";

    export default {
        components: {
            AddDraw,
            EditDraw,
            ClassDraw,
        },
        props: [
            "attr"
        ],
        data() {
            return {
                editItem: {},
                showEdit: false,
                showAdd: false,
                showClass: false,

                form: {
                    keywords: "",
                    enable: null,
                },
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                tableData: [ ],
                lessonTypes: [],
            }

        },

        watch: {
            "form": {
                handler: function (newValue) {
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true

            }
        },

        methods: {
            ...mapMutations(["openTab"]),
            add() {
                this.editItem = {};
                this.showAdd = true;
            },
            edit(item) {
                this.editItem = {...item};
                this.showEdit = true;

            },
            setClass(item) {
                this.editItem = {...item};
                this.showClass = true;
            },
            setLesson(item) {
                // console.log("------------------------")
                // console.log(item);
                this.openTab({
                    funcKey: "school_page_lesson_manage",
                    attr: {lessonSystem: item},
                    title: "总部体系:"+item.name,
                    allowDuplicate: true
                })
            },
            del(item) {
                this.$ajaxGet("/lessonSystem/del/" + item.id, (data) => {
                    this.loadData();
                })
            },

            modifyEnable(item) {
                this.$ajaxGet("/lessonSystem/toggleEnable/" + item.id + "-" + item.enable);
            },

            loadData() {
                this.$ajaxPost("/lessonSystem/schoolList", {
                    form: this.form,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                    this.showEdit = false;
                    this.showAdd = false;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
            loadLessonTypes() {
                this.$ajaxGet("/common/lessonType", (data) => {
                    this.lessonTypes = data.result;
                })
            },

        },

        created() {
            this.loadData();
            this.loadLessonTypes();
        }

    }
</script>
